/**
 * One glyph per appearance mode the scheme toggle offers — the same three
 * values `resolveScheme` takes: `"light"`, `"dark"`, `"system"`
 * (contracts/web-surface.md §4).
 *
 * The toggle itself carries the accessible name, because only the toggle knows
 * both the purpose and the current state ("Appearance: dark"), which FR-019(b)
 * requires it to say. So these are left decorative — see `glyph.tsx`.
 */

import { Glyph, type GlyphProps } from "./glyph";

/** Light appearance. */
export function SunGlyph(props: GlyphProps) {
  return (
    <Glyph {...props}>
      <circle cx="12" cy="12" r="4.25" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.2 2.2M16.9 16.9l2.2 2.2M19.1 4.9l-2.2 2.2M7.1 16.9l-2.2 2.2" />
    </Glyph>
  );
}

/** Dark appearance. */
export function MoonGlyph(props: GlyphProps) {
  return (
    <Glyph {...props}>
      <path d="M20.92 13.17A9 9 0 1 1 10.83 3.08 7.5 7.5 0 0 0 20.92 13.17Z" />
    </Glyph>
  );
}

/**
 * Follow the operating system. A display rather than a half-filled disc: the
 * point is *where* the choice is being made, not what it currently resolves to.
 */
export function SystemGlyph(props: GlyphProps) {
  return (
    <Glyph {...props}>
      <rect x="2.5" y="4" width="19" height="12.5" rx="2" />
      <path d="M12 16.5V20M8 20h8" />
    </Glyph>
  );
}
